import { buildCoachVeeraRoute } from "@/lib/veeraRoutes";

export const COACH_IDENTITY_BUILDER_KICKOFF_PROMPT =
  "Help me refine My Coaching System in a conversational way. Start by asking what would make this most useful and which part of the system we should work on first: voice, philosophy, frameworks, guardrails, supporting materials, or practice alignment. Ask one focused question at a time. Keep a working draft, but be explicit that chat does not silently save changes. Any updates must become reviewable items that I approve inside My Coaching System before they shape runtime behavior.";

export const COACH_IDENTITY_PHILOSOPHY_KICKOFF_PROMPT =
  "Help me create or refine my coaching philosophy in a conversational way. Start with one focused thought-jogger about what I believe helps leaders grow and change. If I ask for examples, frameworks, comparisons, a rewrite, or a simpler explanation, answer directly before asking another question. If I ask to save, finalize, or use the collaborated philosophy, turn it into a reviewable draft for My Coaching System. Do not silently save anything; I need to approve proposed updates before they shape Coach Veera.";

export function buildCoachIdentityVeeraRoute() {
  return buildCoachVeeraRoute({
    contextType: "coach",
    action: "coach-identity-builder",
    source: "coaching-system",
    prompt: COACH_IDENTITY_BUILDER_KICKOFF_PROMPT,
  });
}

export function buildCoachIdentityPhilosophyVeeraRoute() {
  return buildCoachVeeraRoute({
    contextType: "coach",
    action: "coach-identity-builder",
    source: "coaching-philosophy",
    prompt: COACH_IDENTITY_PHILOSOPHY_KICKOFF_PROMPT,
  });
}

export type CoachIdentityGuidedFormSection =
  "frameworks" | "guardrails" | "materials" | "import";

export function buildCoachIdentityGuidedFormRoute(
  section?: CoachIdentityGuidedFormSection,
) {
  return section
    ? `/coach/identity/guided-form?section=${section}`
    : "/coach/identity/guided-form";
}
